export default __webpack_public_path__ + "25776b06ed6f825fdd20738ef91b0266.png";